import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "nex_strumenti_code";

export const getStoredCode = () => sessionStorage.getItem(KEY);

export const applyAccessCode = (code) => {
  axios.defaults.headers.common["X-Access-Code"] = code;
};

export const AccessGate = ({ onOk }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/strumenti/verify`, { code });
      const clean = code.trim().toUpperCase();
      sessionStorage.setItem(KEY, clean);
      applyAccessCode(clean);
      onOk();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Codice non valido");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-ink">
      <div className="mx-auto max-w-md px-5 pb-24 pt-28">
        <div className="rounded-3xl border border-line bg-panel p-8 text-center" data-testid="strumenti-gate">
          <Lock size={26} className="mx-auto text-terracotta" />
          <h1 className="mt-4 font-serif text-2xl tracking-tight text-bone">Area riservata allo studio</h1>
          <p className="mt-2 text-sm text-stone">Inserisci il codice d'accesso per aprire CRM e business plan.</p>
          <form onSubmit={submit} className="mt-6">
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Codice di accesso"
              autoFocus
              data-testid="strumenti-code-input"
              className="w-full rounded-xl border border-line bg-ink px-4 py-3 text-center text-sm tracking-[0.3em] text-bone focus:border-terracotta focus:outline-none"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="strumenti-code-submit"
              className="mt-4 w-full rounded-full bg-terracotta px-6 py-3.5 font-accent text-xs font-semibold uppercase tracking-[0.18em] text-[#1c0d08] transition-colors duration-300 hover:bg-[#f0695a] disabled:opacity-60"
            >
              {busy ? <Loader2 size={15} className="mx-auto animate-spin" /> : "Entra"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};
